import React, { useState, useContext, useEffect } from "react";
import { FormattedMessage } from "react-intl";
import { Button, Row, Col } from "reactstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import ImgToolTip from "../../components/ImgTooltip";
import { useIntl } from "react-intl";
import getS3FileUrl from "../../helpers/getS3FileUrl";
import { DateTime } from "luxon";

import EventContext from "../../contexts/event";
import UserContext from "../../contexts/user";
import getEncodedImageUrl from "../../helpers/get-encoded-image";
import { Presentation, User } from "../../types/presentation";
import axios from "axios";
import {
  PresentationVersion,
  Version,
} from "../../types/presentation";
import { timeFromMinutes } from "../../helpers";
import SocketClient from "../../helpers/connection";
import Swal from "sweetalert2";
import { text } from "@fortawesome/fontawesome-svg-core";
import getS3ImageUrl from "../../helpers/getS3ImageUrl";

const SchedulePresentation: React.FC<{
  presentation: Presentation;
  isVirtual: boolean;
  showAgenda: boolean;
  show_video_views: boolean;
  singlepresentation: () => any;
  updatePresentation: any;
}> = ({
  presentation,
  singlepresentation,
  isVirtual,
  showAgenda,
  show_video_views,
  updatePresentation
}) => {
    const { event_slug } = useParams<{
      event_slug: string;
    }>();
    const eventContext = useContext(EventContext);
    const userContext = useContext(UserContext);
    const [openDetails, setOpenDetails] = useState(false);
    const [livePresentation, setLivePresentation] = useState(false);
    const [plays, setPlays] = useState(0);
    const [versionList, setVersionList] = useState<Version[]>([]);
    const [singlePresentation, setSinglePresentation] =
      useState<PresentationVersion>();
    const [versions, setVersions] = useState<Version[]>([]);
    const [pres, setPres] = useState<Presentation>(presentation);
    const [user, setUser] = useState<User[]>([]);
    // setUser(pres?.users);

    const history = useHistory();
    const intl = useIntl();

    const [schedule, setSchedule] = useState(() => {
      let result = false;
      pres.users?.forEach((user) => {
        if (user.id === userContext?.user?.id) {
          console.log(user.id, userContext?.user?.id);

          result = true;
        }
      });
      return result;
    });

    // let token: any = localStorage.getItem(`token-${event_slug}`);
    const slug = document.location.pathname.split("/")[1] || "invalid";

    let token: any = localStorage.getItem(`token-${slug}`);

    const [versionId, setVersionId] = useState("");
    const [myschedule, setMyschedule] = useState(false);


    const [presentationPdfUrl, setPresentationPdfUrl] = useState("#");



    async function getPdfURL() {
      console.log('getS3ImageUrl', 'getPdfURL');
      let pdfUrl;
      if (presentation.pdfUrl)
        pdfUrl = await getS3ImageUrl(presentation.pdfUrl);
      else {
        pdfUrl = await getS3ImageUrl('engagement-864544d1-f0a3-49f4-8c0d-8ab833337ba0/cbcd8d95-3e40-4ea6-a235-b677772144fa_ba481b7a-403c-50ca-ac12-a11a1022aa71_photohomme1.jfif');
        pdfUrl = "#";
      }
      setPresentationPdfUrl(pdfUrl);
    }


    useEffect(() => {
      console.log("api/presentation 1")
      getPdfURL();
    }, []);

    // emit login action to moderator via socket message using an api
    function loginBroadcast(jsonData: any) {
      console.log('loginBroadcast', jsonData)
      const headers = {
        'Content-Type': 'application/json',
      }

      axios.post(`${process.env.REACT_APP_SOCKET_URL}/quiz-user-login`, jsonData, {
        headers: headers
      })
        .then((response) => {
          console.log('loginBroadcast s', response)
        })
        .catch((error) => {
          console.log('loginBroadcast e', error)
        })
    }


    //show quiz page based on live status enabled
    function handleQuizAction() {
      // API cal for check live quiz enabled
      axios({
        method: "POST",
        url: `${process.env.REACT_APP_API_ENDPOINT}/api/quiz/check-live`,
        data: {
          _id: presentation._id,
        },
      })
        .then((response) => {
          // check live quiz enabled
          if (response.data.live) {
            // loginBroadcast({name:userContext.user?.name,code:values.code,presentationId:presentation._id,createdAt:Date.now()});
            // SocketClient.sendMessage(`{"action":"sendMessage","message":"${presentation._id}:quizLogin@${userContext.user?.name}"}`);
            history.push(
              `/${eventContext.slug}/${presentation._id}/quiz-intro`
            )
          } else {
            // show normal quiz page
            history.push(
              `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
            )
          }
        })
        .catch((error) => {
          console.log("LIVVV error", error);
        });
    }

    console.log("presentation", presentation);


    useEffect(() => {

      axios
        .get(
          `${process.env.REACT_APP_API_ENDPOINT}/api/presentation/${presentation._id}/plays`,
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        )
        .then((response) => {
          setPlays(response.data.data);
        })
        .catch((error) => {
          console.log(error);
        });

    }, [presentation]);

    // const slug = document.location.pathname.split("/")[1] || "invalid";

    //extact a presentation id
    // const p_id = document.location.pathname.split("/")[3] || "invalid";

    // useEffect(() => {
    //    console.log("here----111");
    //   axios
    //     .get<VersionList>(
    //       `
    //       ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/presentation/${presentation._id}`,
    //       {
    //         headers: {
    //           Authorization: `Bearer ${token}`,
    //         },
    //       }
    //     )
    //     .then((response) => {
    //        console.log(
    //         "response presentation-----------------------------------------------------------------------------------------------------",
    //         response.data.data.versions
    //       );
    //       setSinglePresentation(response.data.data);
    //       setVersionList(response.data.data.versions);
    //       setVersions(response.data.data.versions);
    //       const presentation_version: Version[] = response.data.data.versions;
    //       // checkedState.length = presentation_version.length;
    //       // checkedState.fill(false);
    //       // checkedStatus.length = presentation_version.length;
    //       // checkedStatus.fill(false);
    //     })
    //     .catch((error) => {
    //        console.log(error);
    //     });
    // }, []);

    console.log("home", "SchedulePresentation");
    console.log("home", presentation);
    console.log("home", presentation);


    let versionItem = presentation.versions?.filter(function (version) {
      return version.online == true;
    });

    useEffect(() => {
      console.log("Watchvideo button enabled in schedule page.");
    }, [presentation.publicVideo])


    const upadteScheduleStatus = (schedule: any) => {
      if (schedule == false && userContext?.user?.id) {
        setSchedule((s) => !s);
        
        // setPres((pres) => {
        //   let updateUser: any = pres?.users;
        //    console.log(
        //     "checking before update user --------------------",
        //     updateUser
        //   );
        //   let newUser: any = [];
        //
        //   updateUser?.push({
        //     id: userContext?.user?.id,
        //   });
        //
        //   pres.users = updateUser;
        //   return pres;
        // });

        axios
          .patch(
            `
  ${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${presentation._id}/my-schedule/${presentation.event_id}`,
            {
              id: userContext?.user?.id,
            }
          )
          .then((res) => {
            console.log(res.data.users, "-----------------------myschedule-res");
            // setUser(res.data.users);
            setPres(res.data);
            setSchedule(true);

            return updatePresentation(res.data)

          });
      }
      console.log();
      
      if (schedule == true && userContext?.user?.id) {
        // setPres((pres) => {
        //   const updateUser = pres?.users;
        //   let newUser: any = [];
        //   updateUser?.map((user) => {
        //     if (user?.id != userContext.user?.id) {
        //       newUser.push({
        //         ...updateUser,
        //       });
        //     }
        //   });
        //
        //   pres.users = newUser;
        //   return pres;
        // });
        setSchedule((s) => !s);

        axios
          .delete(
            `
${process.env.REACT_APP_API_ENDPOINT}/api/speaker-data/${presentation._id}/my-schedule/${presentation.event_id}/${userContext?.user?.id}`
          )
          .then((res) => {
            console.log(res.data.users, "-----------------------myschedule-res");
            // setUser(res.data.users);
            setPres(res.data);
            setSchedule(false);
            updatePresentation(res.data)
          });
      }
    };

    function sameDay(d1: DateTime, d2: DateTime) {
      return d1.year === d2.year &&
        d1.month === d2.month &&
        d1.day === d2.day;
    }

    return (
      <>
        {presentation.header && (
          <div className="day-text-schedule">
            <span className="day">{intl.formatMessage({ id: 'day' })}  {presentation.day}</span>
            <span className="date">
              {DateTime.fromISO(presentation.date)
                .setLocale(intl.locale)
                .toLocaleString(DateTime.DATE_HUGE)}
            </span>
          </div>
        )}
        <div className="schedule-bar m-b-20">
          <div className="d-none d-lg-block">
            <Row noGutters>
              {/* <Col sm={1} md={1} lg={1}> */}
              {/* <div className="left-time-container"> */}
              {/* <div className="darkoverlay">
                <img
                  // width="34"
                  // height="42"
                  src={`/images/icon-${presentation.status}-new.svg`}
                  alt="Test"
                /> */}
              {/* <ImgToolTip
                  intl={intl}
                  placement="top"
                  tooltiptext={`ppt-status.${presentation.status}`}
                  id="tooltip-download-latest"
                  img={`/images/icon-${presentation.status}-new.svg`}
                /> */}
              {/* </div> */}
              {/* </div> */}
              {/* </Col> */}
              <Col sm={8} md={8} lg={9}>
                <div className="schedule-contianer">
                  <div className="speaker-presentation d-flex border-radius justify-content-between">
                    {/* user presenattion = pres  */}
                    {presentation.speaker_info &&
                      presentation.speaker_info.picture &&
                      presentation.speaker_info.picture.split("net/")[1] !==
                      "undefined" ? (
                      <img
                        width={76}
                        height={76}
                        src={getEncodedImageUrl(
                          presentation.speaker_info.picture,
                          76,
                          76
                        )}
                        alt={presentation.speaker_info.firstName}
                      />
                    ) : (
                      <img
                        width={76}
                        height={76}
                        src={"/images/placeholder.svg"}
                        alt={presentation.speaker_info.firstName}
                      />
                    )}
                    <div className="speaker-details">
                      <h4>{presentation.name}</h4>

                      <span>
                        {presentation.speaker_info &&
                          presentation.speaker_info.title}{" "}
                        {presentation.speaker_info &&
                          presentation.speaker_info.firstName}{" "}
                        {presentation.speaker_info &&
                          presentation.speaker_info.lastName}
                      </span>
                    </div>
                    <div>
                      <div>
                        {show_video_views ? (
                          <div className="plays-count">
                            <img width="18" height="11" src={`/images/eye.svg`} />
                            <span> {plays}</span>
                          </div>
                        ) : (
                          ""
                        )}
                        {
                          <div
                            className={`schedule-button ${!show_video_views
                              ? "margin-top-abscence-of-views"
                              : ""
                              }`}
                          >
                            {/* userContext.user */}
                            {userContext.user ?
                              schedule ? (
                                <>
                                  <img
                                    src={`/images/my-schedule-blue-light.svg`}
                                    alt="Test"
                                    className="schedule_button_light"
                                    onClick={function () {
                                      // setMyschedule(false);
                                      upadteScheduleStatus(schedule);
                                    }}
                                  />
                                  <img
                                    src={`/images/my-schdeule-blue-dark.svg`}
                                    alt="Test"
                                    className="schedule_button_dark"
                                    onClick={function () {
                                      // setMyschedule(false);
                                      upadteScheduleStatus(schedule);
                                    }}
                                  />
                                </>
                              ) : (
                                // (inside schedule page)
                                <>
                                  <img
                                    src={`/images/my-schedule-white-light.svg`}
                                    alt="Test"
                                    className="schedule_button_light"
                                    onClick={function () {
                                      // setMyschedule(true);
                                      upadteScheduleStatus(schedule);
                                    }}
                                  />
                                  <img
                                    src={`/images/my-schedule-white-dark.svg`}
                                    alt="Test"
                                    className="schedule_button_dark"
                                    onClick={function () {
                                      // setMyschedule(true);
                                      upadteScheduleStatus(schedule);
                                    }}
                                  />
                                </>
                              )
                              : <div style={{ height: "48px", width: "48px" }}></div>}
                          </div>
                        }
                        <div
                          className={`schedule-button-download ${!show_video_views ? "margin-abscence-of-views" : ""
                            }`}
                        >
                          {/* { console.log(
                        "url----------------",
                        "--------",
                        presentation.pdfUrl,
                        "----------",
                        presentation.pdfUrl
                          ? getS3ImageUrl(presentation.pdfUrl)
                          : "#",
                        "---------------",
                        pres?.ppt[pres.ppt.length - 1]?.file
                          ? getS3ImageUrl(
                            pres.ppt[pres.ppt.length - 1].file
                            )
                          : "#"
                      )} */}
                          {presentation.pdfConvert ? (
                            <a
                              // className="trash"
                              //  className="btn_download_photos"
                              // href={`${process.env.REACT_APP_ASSET_URL}${pdfUrl}`}
                              href={presentationPdfUrl}
                              target="_blank"
                              rel="noopener noreferrer"
                              download
                            >
                              <ImgToolTip
                                className={` download_icon download_icon_schedule `}
                                intl={intl}
                                placement="left"
                                tooltiptext="schedule.link.download"
                                id="tooltip-download-latest"
                                img={`/images/schedule-download.svg`}
                              />

                              <ImgToolTip
                                className={`download_icon download_icon_schedule_hover `}
                                intl={intl}
                                placement="left"
                                tooltiptext="schedule.link.download"
                                id="tooltip-download-latest"
                                img={`/images/schedule-download-hover.svg`}
                              />
                            </a>
                          ) : (
                            // <ImgToolTip
                            //     intl={intl}
                            //     placement="top"
                            //     tooltiptext="link.download"
                            //     id={`tooltip-download-ppt-${presentation._id}`}
                            //     img="/icons/download.png"
                            //     // className={""}
                            //     className={"download_icon_schedule"}
                            //   />
                            ""
                          )}
                        </div>
                      </div>

                      {/* <div className="schedule-button-download"> */}
                    </div>
                    {/* <div className="public-link">
                <img width={12} height={16} src={"/icons/link-ico.svg"} />
                  <span>
                    <FormattedMessage id="presentation.public.link" />
                  </span>
                </div> */}
                  </div>
                  <div
                    className={`schedule-details ${openDetails ? "show-details" : "hide-details"
                      }`}
                  >
                    {(presentation.type_info ||
                      presentation.color_info ||
                      presentation.association_info) && (
                        <div
                          className={`details   ${presentation.publicVideo &&
                            presentation.video &&
                            presentation.video.id
                            ? ""
                            : "schedule-border"
                            }`}
                        >
                          <div className="type-theme">
                            {presentation.type_info && (
                              <>
                                <span>
                                  <img
                                    src={getEncodedImageUrl(
                                      presentation.type_info.icon,
                                      36,
                                      36,
                                      "contain"
                                    )}
                                    alt={presentation.type_info.name}
                                  />
                                  {presentation.type_info.name}
                                </span>
                              </>
                            )}
                            <div className="vl"></div>

                            {presentation.color_info && (
                              <span>
                                <span
                                  style={{
                                    backgroundColor: presentation.color_info.color,
                                    width: 40,
                                    height: 40,
                                    borderRadius: 5,
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                  }}
                                ></span>
                                {presentation.color_info.name}
                              </span>
                            )}
                          </div>
                          {presentation.association_info && (
                            <span className="ass">
                              <img
                                // width="40"
                                // height="40"
                                src={getEncodedImageUrl(
                                  presentation.association_info.logo,
                                  36,
                                  36
                                )}
                                // alt={presentation.association_info.name}
                              />
                              {presentation.association_info.name}
                            </span>
                          )}
                        </div>
                      )}
                    {/* double run and this is working for both presentation and version attribute */}
                    {/* || (presentation.versions.find((e) => e.online === true))  */}
                    {/* Diljith Edited here 31/03/2025 Reason: change the location to fetch the thumbnails from thumbnails field inside the version not from outside. */}
                    {(presentation.publicVideo &&
                      presentation.video &&
                      presentation.video.id) && (
                        <div className="watch-video">
                          <Link
                            to={`/${eventContext.slug}/${presentation._id}${document.location.search}`}
                          >
                            <img src="/icons/video.svg" alt="video" />
                            <FormattedMessage id="button.watch-video" />
                          </Link>
                        </div>
                      )}
                    <div className="sch-btns-container-d">

                      {eventContext.forum ? (
                        <React.Fragment>
                          {userContext.user ? (
                            <Link
                              className="sch-btns"
                              to={`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`}
                            >
                              <img alt="forum" src="/icons/forum.svg" />
                              FORUM
                            </Link>
                          ) : (
                            <Button
                              className="sch-btns"
                              onClick={() => {
                                userContext.setRedirectPath(`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`);
                                userContext.setShowLogin(true);
                              }}
                            >
                              <img alt="forum" src="/icons/forum.svg" />
                              FORUM
                            </Button>
                          )}
                        </React.Fragment>
                      ) : (
                        <></>
                      )}

                      {eventContext.quiz ? (

                        <Button
                          className="sch-btns"
                          onClick={() => {

                            if (userContext.user) {
                              console.log("LIVVV", livePresentation);
                              // history.push(
                              //   `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                              // )
                              handleQuizAction();
                            } else {
                              userContext.setShowLogin(true);
                            }

                          }}
                        >
                          <img alt="quiz" src="/icons/quiz.svg" />
                          QUIZ
                        </Button>
                      ) : (
                        <></>
                      )}

                      {(userContext.user?.is_moderator === false) && (userContext.user?.is_speaker === false) && (new Date(presentation.date).toDateString() === new Date().toDateString()) ? (

                        <Button
                          className="sch-btns btn btn-secondary"
                          onClick={() => {
                            window.open(`${process.env.REACT_APP_VISIO}/visio/${presentation._id}/${userContext.user?.id}`, '_self')
                          }}
                        >
                          <img alt="quiz" src="/icons/live-stream.svg" />
                          LIVESTREAM
                        </Button>
                      ) : (
                        <></>
                      )}

                      {/* show manage quiz button : based on user mode   */}
                      {(eventContext.quiz === true && userContext.user?.is_moderator === true) || (userContext.user?.speaker_id === presentation.speaker_id) ? (

                        <Button
                          className="sch-btns"
                          onClick={() => {
                            history.push(
                              `/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`
                            );
                          }}
                        >
                          <img alt="quiz" src="/icons/quiz.svg" />
                          MANAGE QUIZ
                        </Button>
                      ) : (
                        <></>
                      )}
                      {/* {eventContext.quiz &&
                  eventContext.presentationsWithResults.indexOf(
                    presentation._id
                  ) > -1 ? (
                    <Button
                      className="sch-btns"
                      onClick={() => {
                        userContext.user
                          ? history.push(
                              `/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`
                            )
                          : userContext.setShowLogin(true);
                      }}
                    >
                      <img alt="quiz" src="/icons/quiz.svg" />
                      <FormattedMessage id="quiz.results" />
                    </Button>
                  ) : (
                    <></>
                  )} */}
                      {/* {showAgenda ? (
                    <Button
                      className="sch-btns"
                      onClick={() => alert("work in progress")}
                    >
                      <img alt="agenda" src="/icons/agenda.svg" />
                      AGENDA
                    </Button>
                  ) : (
                    <></>
                    )} */}
                      {/* +&nbsp; */}
                      {/* TODO: WIP */}
                      {/* {eventContext.quiz &&
                  (userContext.user?.moderator ||
                    [presentation.speaker_id, presentation.association_id]
                      .map((i) => i)
                      .includes(userContext.user?.external_id || "")) ? (
                    <Button
                      className="sch-btns"
                      onClick={() => {
                        history.push(
                          `/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`
                        );
                      }}
                    >
                      <img alt="quiz" src="/icons/quiz.svg" />
                      <FormattedMessage id="quiz.management" />
                    </Button>
                  ) : (
                    <></>
                  )} */}
                    </div>
                  </div>
                </div>
              </Col>
              <Col sm={3} md={3} lg={2}>
                <div className="time-container-schedule">
                  <div className="darkoverlay">
                    {isVirtual ? (
                      <h5>&nbsp;</h5>
                    ) : (
                      <h5>
                        {timeFromMinutes(presentation.time)} -{" "}
                        {timeFromMinutes(presentation.end_time)}
                      </h5>
                    )}
                    {isVirtual ? (
                      <span>&nbsp;</span>
                    ) : (
                      presentation.room_info && (
                        <span>{presentation.room_info.name}</span>
                      )
                    )}
                  </div>
                  <Button
                    onClick={() => setOpenDetails(!openDetails)}
                    color="primary"
                    className="arrow-button"
                  >
                    <img
                      className={openDetails ? "chev-rotate" : ""}
                      src="/icons/chev-white.svg"
                      alt="chev-white"
                    />
                  </Button>
                </div>
              </Col>
            </Row>
          </div>
          {/* Mobile Below */}
          <div className="d-block d-lg-none">
            <Row noGutters>
              <Col xs={8}>
                <div className="schedule-contianer_mo_schedule">
                  <div className="speaker-presentation_mop">
                    {presentation.name.length > 72 ? (<h4 className="speaker-presentation_mo" onClick={() => {
                      Swal.fire({ text: presentation.name })
                    }}>
                      {presentation.name.slice(0, 70)}...
                    </h4>) : (<h4 className="speaker-presentation_mo">
                      {presentation.name}
                    </h4>)}


                    {show_video_views ? (
                      <div className="plays-count">
                        <img width="18" height="11" src={`/images/eye.svg`} />
                        <span> {plays}</span>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </Col>
              <Col xs={4}>
                <div className="schedule-contianer_mo_schedule_time">
                  <div className="speaker-presentation_mop">
                    {/* <h4 className="speaker-presentation_mo">{presentation.name}</h4>
                   */}

                    <div className="time_content">
                      {timeFromMinutes(presentation.time)}
                      {/* -{" "}
                  {timeFromMinutes(presentation.end_time)} */}
                    </div>
                    <div className="time_content">
                      {/* {timeFromMinutes(presentation.time)} -{" "} */}
                      {timeFromMinutes(presentation.end_time)}
                    </div>
                    {presentation.room_info && (
                      <span className="room_content">
                        {presentation.room_info.name}
                      </span>
                    )}
                  </div>
                </div>
              </Col>
            </Row>
            <Row noGutters>
              <Col xs={2}>
                {/* <div className="schedule-contianer">
              <div className="speaker-presentation-footer"> */}
                <div className="presentation-icon_mo_schedule" >

                  {
                    userContext.user ?
                      schedule ? (
                        <>
                          <img
                            src={`/images/myschedule-dark.svg`}
                            alt="Test"
                            className="schedule_button_dark"
                            onClick={function () {
                              // setMyschedule(true);
                              upadteScheduleStatus(schedule);
                            }}
                          />
                        </>
                      ) : (
                        <>

                          <img
                            src={`/images/myschedule.svg`}
                            alt="Test"
                            className="schedule_button_light"
                            onClick={function () {
                              // setMyschedule(false);
                              upadteScheduleStatus(schedule);
                            }}
                          />
                        </>
                      )
                      : ""
                  }
                </div>
                {/* </div> */}
                {/* </div> */}
              </Col>
              {/* <div className="public-link">
                {/* <img width={12} height={16} src={"/icons/link-ico.svg"} />
                <span>
                <FormattedMessage id="presentation.public.link" />
              </span> */}
              {/* </div> */}
              {/* </Col> */}
              <Col xs={6}>
                {/* <div className="time-container_mo time-container-mob">
              <div className="darkoverlay_mo ">
                <h5>
                  {timeFromMinutes(presentation.time)} -
                  {timeFromMinutes(presentation.end_time)}
                </h5>
                {presentation.room_info && (
                  <span>{presentation.room_info.name}</span>
                )}
              </div>
            </div> */}
                <div
                  className={
                    presentation.pdfConvert
                      ? "time_room_schedule"
                      : "time_room_schedule_white"
                  }
                >
                  {presentation.pdfConvert ? (
                    <>
                      <a
                        // className="trash"
                        //  className="btn_download_photos"
                        // href={`${process.env.REACT_APP_ASSET_URL}${pdfUrl}`}
                        href={presentationPdfUrl}
                        // href={
                        //   presentation.ppt.length > 0
                        //     ? getS3ImageUrl(
                        //         presentation?.ppt[presentation.ppt.length - 1]?.file
                        //       )
                        //     : "#"
                        // }
                        //  target="_blank"
                        rel="noopener noreferrer"
                      >
                        <img
                          width="34"
                          // height="42"
                          src={`/images/schedule-download-dark.svg`}
                          alt="Test"
                          onClick={function () {
                            if (presentation.pdfUrl) {
                              // presentationPdfUrl
                            }
                          }}
                        />
                      </a>
                    </>
                  ) : (
                    ""
                  )}

                  {presentation.pdfConvert ? <span>PDF</span> : ""}
                  {/* <div className="time_room_content">
                <div className="time_content">
                  {timeFromMinutes(presentation.time)} -{" "}
                  {timeFromMinutes(presentation.end_time)}
                </div>
                {presentation.room_info && (
                  <span className="room_content">
                    {presentation.room_info.name}
                  </span>
                )}
              </div> */}
                </div>
              </Col>
              <Col xs={4}>
                <div className="time-container time-container-mob">
                  <div className={` ${openDetails && presentation.publicVideo &&
                    presentation.video &&
                    presentation.video.id ? "" : "arrow"}  btn-primary`}>
                    <Button
                      onClick={() => setOpenDetails(!openDetails)}
                      color="primary"
                    >
                      <img
                        className={openDetails ? "chev-rotate" : ""}
                        src="/icons/chev-white.svg"
                        alt="chev-white"
                      />
                    </Button>
                  </div>
                </div>
              </Col>
              {openDetails && presentation.publicVideo &&
                presentation.video &&
                presentation.video.id && (
                  <Col xs={12} className={"watch"}>

                    <Link
                      className="schedule-btns trans"
                      to={`/${eventContext.slug}/${presentation._id}${document.location.search}`}
                    >
                      <img src="/icons/video.svg" alt="video" />
                      <span style={{ color: "white" }}>
                        <FormattedMessage id="button.watch-video" />
                      </span>
                    </Link>

                  </Col>
                )}


            </Row>
            <Row>
              <Col>
                <div className="schedule-contianer">
                  <div
                    className={`schedule-details mobile ${openDetails ? "show-details" : "hide-details"
                      }  `}
                  >
                    {(presentation.type_info ||
                      presentation.color_info ||
                      presentation.association_info) && (
                        <div className={`details     `}>
                          <div className="type-theme">
                            {presentation.type_info && (
                              <div>
                                <img
                                  width={44}
                                  height={40}
                                  src={getEncodedImageUrl(
                                    presentation.type_info.icon,
                                    30,
                                    30
                                  )}
                                  alt={presentation.type_info.name}
                                />
                                <span>{presentation.type_info.name}</span>
                              </div>
                            )}
                            {/* changes */}
                          </div>
                          <div>
                            {presentation.color_info && (
                              <div>
                                <div
                                  style={{
                                    backgroundColor: presentation.color_info.color,
                                    width: 44,
                                    height: 40,
                                    borderRadius: 5,
                                    display: "inline-block",
                                    verticalAlign: "middle",
                                  }}
                                ></div>
                                <span>{presentation.color_info.name}</span>
                              </div>
                            )}
                          </div>
                          {presentation.association_info && (
                            <div className="ass" style={{ marginTop: "10px" }}>
                              {presentation.association_info.logo ? (
                                <img
                                  width={44}
                                  height={40}
                                  src={getEncodedImageUrl(
                                    presentation.association_info.logo,
                                    30,
                                    30
                                  )}
                                  alt="type"
                                />
                              ) : (
                                ""
                              )}

                              <span>{presentation.association_info.name}</span>
                            </div>
                          )}
                        </div>
                      )}
                    {/* {presentation.publicVideo &&
                presentation.video &&
                presentation.video.id ? (
                  <div className="watch-video">
                    <Link
                      to={`/${eventContext.slug}/${presentation._id}${document.location.search}`}
                    >
                      <img src="/icons/video.svg" alt="video" />
                      <FormattedMessage id="button.watch-video" />
                    </Link>
                  </div>
                ) : (
                  presentation.versions?.some((el) => el.online === true) && (
                    <div className="watch-video">
                      <Link
                        // "bad42d86-2860-51b2-a2e5-52a608b4ae6d"
                        to={`/${eventContext.slug}/my-pres/${presentation._id}/video/${versionItem[0]?.versionId}/watch`}
                      >
                        <img src="/icons/video.svg" alt="video" />
                        <FormattedMessage id="button.watch-video" />
                      </Link>
                    </div>
                  )
                )} */}
                    {/* {presentation.publicVideo &&
                  presentation.video &&
                  presentation.video.id && (
                    <div
                      className="details"
                      // className="watch-video"
                    >
                      <div
                        className="schedule-btns"

                        // className="type-theme"
                      >
                        <Link
                          to={`/${eventContext.slug}/${presentation._id}${document.location.search}`}
                        >
                          <img src="/icons/video.svg" alt="video" />
                          <FormattedMessage id="button.watch-video" />
                        </Link>
                      </div>
                    </div>
                  )} */}

                    {/* <div className="sch-btns-container-schedule"> */}
                    <div className="mobile-buttons">
                      {/* {presentation.versions?.some((el) => el.online === true) && (
                    <Link
                      // "bad42d86-2860-51b2-a2e5-52a608b4ae6d"
                      className="schedule-btns"
                      to={`/${eventContext.slug}/my-pres/${presentation._id}/video/${versionItem[0]?.versionId}/watch`}
                    >
                      <img src="/icons/video.svg" alt="video" />
                      <FormattedMessage id="button.watch-video" />
                    </Link>
                  )} */}


                      {/* <Button
                    className="schedule-btns"
                    onClick={() => {
                      userContext.user
                        ? history.push(
                            `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                          )
                        : userContext.setShowLogin(true);
                    }}
                  >
                    <img alt="quiz" src="/icons/my-videos-ico.svg" />
                    <FormattedMessage id="presentation.my.videos" />
                  </Button> */}
                      {eventContext.forum ? (
                        <Link
                          className="sch-btns btn btn-secondary"
                          to={`/${eventContext.slug}/${presentation._id}/forum${document.location.search}`}
                        >
                          <img alt="forum" src="/icons/forum.svg" />
                          <span>FORUM  </span>
                        </Link>
                      ) : (
                        <></>
                      )}

                      {eventContext.quiz ? (
                        // below line of code giving always false value
                        // &&
                        // eventContext.presentationsWithQuestions.indexOf(
                        //   presentation._id
                        // ) > -1 ?
                        <Button
                          className="sch-btns btn btn-secondary"
                          onClick={() => {
                            // userContext.user
                            //   ? history.push(
                            //     `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                            //   )
                            //   : userContext.setShowLogin(true);
                            if (userContext.user) {
                              console.log("LIVVV", livePresentation);
                              // history.push(
                              //   `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                              // )
                              handleQuizAction();
                            } else {
                              userContext.setShowLogin(true);
                            }
                          }}
                        >
                          <img alt="quiz" src="/icons/quiz.svg" />
                          QUIZ
                        </Button>
                      ) : (
                        <></>
                      )}

                      {/* eventContext.presentationsWithQuestions.indexOf(
                    presentation._id
                  ) > -1 ?  */}
                      {/* {eventContext.quiz ? (
                    <Button
                      className="schedule-btns"
                      onClick={() => {
                        history.push(
                          `/${eventContext.slug}/${presentation._id}/quiz${document.location.search}`
                        );
                      }}
                    >
                      <img alt="quiz" src="/icons/quiz.svg" />
                      <span> QUIZ</span>
                    </Button>
                  ) : (
                    <></>
                  )} */}
                      {/* &&
                  eventContext.presentationsWithResults.indexOf(
                    presentation._id
                  ) > -1  */}
                      {/* {eventContext.quiz? (
                    <Button
                      className="sch-btns"
                      onClick={() => {
                        history.push(
                          `/${eventContext.slug}/${presentation._id}/quiz-results${document.location.search}`
                        );
                      }}
                    >
                      <img alt="quiz" src="/icons/quiz.svg" />
                      QUIZ RESULTS
                    </Button>
                  ) : (
                    <></>
                  )} */}
                      {/* {showAgenda ? (
                    <Button
                      className="schedule-btns"
                      onClick={() => alert("work in progress")}
                    >
                      <img alt="agenda" src="/icons/agenda.svg" />
                      <span>AGENDA</span>
                    </Button>
                  ) : (
                    <></>
                    )} */}
                      {/* + */}





                      {(eventContext.quiz === true && userContext.user?.is_moderator === true) || (userContext.user?.is_speaker && userContext.user?.speaker_id === presentation.session_id) ? (

                        <Button
                          className="sch-btns btn btn-secondary"
                          onClick={() => {
                            history.push(
                              `/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`
                            );
                          }}
                        >
                          <img alt="quiz" src="/icons/quiz.svg" />
                          MANAGE QUIZ
                        </Button>
                      ) : (
                        <></>
                      )}

                      {(userContext.user?.is_moderator === false) && (userContext.user?.is_speaker === false) && (new Date(presentation.date).toDateString() === new Date().toDateString()) ? (

                        <Button
                          className="sch-btns btn btn-secondary"
                          onClick={() => {
                            window.open(`${process.env.REACT_APP_VISIO}/visio/${presentation._id}/${userContext.user?.id}`, '_self')
                          }}
                        >
                          <img alt="quiz" src="/icons/live-stream.svg" />
                          LIVESTREAM
                        </Button>
                      ) : (
                        <></>
                      )}


                      {/* {eventContext.quiz &&
                  (userContext.user?.moderator ||
                    [presentation.speaker_id, presentation.association_id]
                      .map((i) => i)
                      .includes(userContext.user?.external_id || "")) ? (
                    <Button
                      className="sch-btns"
                      onClick={() => {
                        history.push(
                          `/${eventContext.slug}/${presentation._id}/quiz-moderator${document.location.search}`
                        );
                      }}
                    >
                      <img alt="quiz" src="/icons/quiz.svg" />
                      <FormattedMessage id="quiz.management" />
                    </Button>
                  ) : (
                    <></>
                  )} */}
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          </div>
        </div>
      </>
    );
  };

export default SchedulePresentation;
